import { defineMessages } from "react-intl";

const baseId = "t.components.modals.otpCaMobileModal.";

export default defineMessages({
  panelTitle: {
    id: baseId + "panelTitle",
    defaultMessage: "Organizational unit editing",
  },
  otpLabel: {
    id: baseId + "otpLabel",
    defaultMessage: "Otp",
  },
  close: {
    id: baseId + "close",
    defaultMessage: "Close",
  },
  confirm: {
    id: baseId + "confirm",
    defaultMessage: "Confirm",
  },
});
